import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'

import Icon from '../../Shared/Icon/Icon'

class CompetitionDropzone extends React.Component {
  constructor() {
    super()

    this.state = {
      dropzoneActive: false,
    }
  }

  componentDidMount() {
    let counter = 0

    window.addEventListener('dragenter', () => {
      this.setState({
        dropzoneActive: true,
      })
      counter++
    })

    window.addEventListener('dragleave', () => {
      counter--
      if (counter === 0) {
        this.setState({
          dropzoneActive: false,
        })
      }
    })

    window.addEventListener('drop', () => {
      counter = 0
      this.setState({
        dropzoneActive: false,
      })
    })
  }

  render() {
    return (
      <div className="dropzone-container">
        <Dropzone
          className={`drop-area ${this.state.dropzoneActive ? 'is-active' : ''}`}
          onDrop={this.props.onDrop}
          accept=".png,.jpg,.jpeg, image/png,image/jpeg,image/jpg"
        >
          <div className="drop-area__text">Drag and drop your images <strong>here</strong></div>
          <Icon type={['fal', 'image']} color="grey-light" />
        </Dropzone>
        <div className="separator">
          <div className="separator__text">or</div>
          <hr />
        </div>
        <div className="drop-area__button button--file">
          <button className={`btn btn-block btn-lg ${this.props.buttonClass}`} type="submit">Attach files</button>
          <input
            type="file"
            name="file"
            multiple
            onChange={(e) => this.props.openModal([...e.target.files], true)}
            accept=".png,.jpg,.jpeg, image/png,image/jpeg,image/jpg"
          />
        </div>
        <p className="terms-text">
          <small>
            The uploaded images should be <strong>high-resolution</strong> (minimum 1280 pixels) and <strong>less than 10MBs</strong>.
            <br />
            Acceptable formats: <strong>png, jpg, jpeg</strong>.
          </small>
        </p>
      </div>
    )
  }
}

CompetitionDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  buttonClass: PropTypes.string.isRequired,
}

export default CompetitionDropzone
